<script>
export default {
  name: "MultiSectionQuestionModal"
}
</script>

<template>
<div>I ll be there soon </div>
</template>

<style scoped>

</style>